import Client from './client';

export default class ShopifyGiftCardBalances extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/shopify/gift/cards/balances`, {
      ...options,
       method: 'POST',
    });
  }

}
